import Modal from "../../../../parts/modal-new";
import {
  getDivisor,
  getIntervalString,
} from "../../../../utils/stripe-helpers";

export const PlanDetails = ({ plan, type = "press", user }) => {
  const { pressCustomBranding = {} } = user;
  const {
    nickname,
    currency,
    unit_amount,
    recurring,
    metadata = {},
    features,
    activeCount,
    facilikey = [],
  } = plan;
  const { access, trial_days } = metadata;
  const divisor = getDivisor(currency);
  const price = unit_amount / divisor;
  const { gymLocations = [] } = pressCustomBranding;
  const locations = gymLocations.filter((value) =>
    facilikey.includes(value.facilikey)
  );

  const planName =
    type === "push" ? getIntervalString(recurring) : nickname || "-";

  return (
    <Modal className="Plan-Modal" title={planName} toClear={["plan", "type"]}>
      <div className="body modal-body">
        <p className="p2">Name</p>
        <p>{planName}</p>
        <p className="p2">Price</p>
        <p>{price}</p>
        <p className="p2">Currency</p>
        <p>{currency.toUpperCase()}</p>
        <p className="p2">Interval</p>
        <p>{getIntervalString(recurring)}</p>
        <p className="p2">Included (Features)</p>
        {features?.length ? (
          <ul>
            {features.map((feature) => (
              <li key={feature} className="value">
                {feature}
              </li>
            ))}
          </ul>
        ) : (
          <span className="value">-</span>
        )}
        {type === "press" && access && (
          <>
            <p className="p2">User Access</p>
            <p>
              {access.toUpperCase()} Access ({activeCount}{" "}
              {activeCount === 1 ? "user" : "users"})
            </p>
          </>
        )}
        {type !== "press" && (
          <>
            <p className="p2">Users</p>
            <p>{activeCount}</p>
          </>
        )}
        {type === "push" && (
          <>
            <p className="p2">Free trial</p>
            <p>
              {!trial_days
                ? "No"
                : trial_days > 1
                ? `${trial_days} days`
                : `${trial_days} day`}
            </p>
          </>
        )}
        {locations.length ? (
          <>
            <p className="p2">Key Access</p>
            <ul>
              {locations.map(({ gymName, gymLocation, gymContact }) => (
                <li
                  key={`${gymName}-${gymLocation}-${gymContact}`}
                  className="value"
                >
                  {gymName} ({gymLocation})
                </li>
              ))}
            </ul>
          </>
        ) : null}
      </div>
    </Modal>
  );
};
